import { createGlobalStyle, keyframes } from 'styled-components';
import { defaultTheme } from '../config';


const blurEnter= keyframes`
0% {
display: flex;
width: 100%;
height: 0px;
opacity: 1;

   
    padding: 0px;
  
}
15% {
display: flex;
width: 100%;
height: 0px;
opacity: 1;

    padding: 0px;
    opacity: 1;
}
25% {
  filter: blur(20px);
  padding: 20px;
  width: 100%;
    height: auto;
    opacity: 1;
  
}
30%{
  filter: blur(0px);opacity: 1;
}
100%{ 
  width: 100%;
    height: auto;

   padding: 20px;
   filter: blur(0);opacity: 1;
}
`;

const float= keyframes`
0% {
  box-shadow: 0px 0px 0px rgba(0,50,200,0.1);
  opacity: 0.7;
}
100% {
  box-shadow: 0px 0px 20px rgba(0,50,200,0.7);
  opacity: 0.9;
}
`;

const pulsing= keyframes`
0% {
  box-shadow: 0px 0px 5px rgba(0,0,0,0.3);
  opacity: 0.7;
}
100% {
  box-shadow: 0px 0px 15px yellow;
  opacity: 1;
}
`;

const move= keyframes`
0% {

  width: 0px;

  height: 8px;
  
}
20% {

width: 0px;

height: 8px;

}
30%{
  width: 0px;

  height: 8px;

}
35%{
  width: 0px;

  height: 8px;
  top: 85%;
}
45%{
  width: 100%;

  height: 8px;
  top: 85%;
}
100%{
  width: 100%;

  height: 8px;
  top: 85%;
}


`;

export default createGlobalStyle`

@font-face {
    font-family: Montserrat;
    src: url("/assets/fonts/Montserrat-Regular.ttf") format("truetype");
}


@font-face {
    font-family: MontserratBold;
    src: url("/assets/fonts/Montserrat-Bold.ttf") format("truetype");
}


*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0
}

html{
  width: 100%;
  min-height: 100vh !important;


  color: rgb(255, 255, 255);
    -webkit-font-smoothing: antialiased;
    position: relative;
    min-height: 100% !important;
    background: #000;
    padding: 0px;
    margin: 0px !important;

  overflow-y: auto;
  @media print {
      background: #fff;
      height: auto;
    }
}

body {

background: url('/assets/evento/Fundo.jpeg') no-repeat center;
background-attachment: fixed;
background-size: cover;
  

  @media print {
      background: #fff;
      height: auto;
    }

}

.lightPulse {
  filter: drop-shadow(0px 0px 5px #fff);
}

#root{
  min-height: 100vh;
  background: rgba(0,0,0,0.7);

  @media print {
      background: #fff;
      height: auto;
    }

}

body, input, button{
  font-family: Helvetica,  sans-serif;
  font-size: 16px;
}

h1,h2,h3,h4,h5,h6, strong{
font-weight: 400;
font-family:  'MontserratBold',Helvetica,  sans-serif;


}

h2{

      font-size: 16px;
}

p, span{
  font-family:'Montserrat',Helvetica,  sans-serif;
}

button{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  >svg {
    margin: 0 5px;
  }
}

.wave {

  width: 200%;
  margin-left: -20%;
  z-index:0;

  @media (max-width: 1250px) {
    width: 400%;
    margin-left: -50%;
  }

  @media (max-width: 750px) {
    width: 800%;
    margin-left: -50%;
  }



}


.computerOnly{
display: flex;
@media (max-width: 1200px) {
    display: none;
  }
}

.mobileOnly{
display: none;
@media (max-width: 1200px) {
    display: flex;
  }
}

button.defaultButton {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: rgb(0,100,50) !important;
      color: #fff !important;

      display: flex;
      justify-content: center;
      text-align: center;

      transition: 0.5s all;
      border: 0;
      border-radius: 8px;
      margin: auto;
      margin-top: 5px;
     


      &:hover {
 
      transform: translateY(-3px);
      box-shadow: 0px 5px 10px rgba(255,255,100,0.3);
      }
    }


    button.defaultButtonReverse {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: #fff !important;
      color: rgb(0,100,50) !important;
      

      display: flex;
      justify-content: center;
      text-align: center;

      transition: background 0.5s;

      border-radius: 8px;
      margin: auto;
      margin-top: 5px;
      font-weight: bold;
      opacity: 1;

      border: 2px solid #fff;

      transition: 0.5s all;

      &:hover{
        box-shadow: 0px 5px 35px rgba(255,255,255,0.5);
        transform: translateY(-10px);
      }
    
    }

    button.defaultButtonMini {
         margin-top: 0px !important;
         padding: 10px !important;
      width:auto !important;
      min-width:auto !important;
     
      text-align: center !important;
      justify-content: center !important;
      background: rgb(0,100,50) !important;
      color: #fff !important;
      font-weight: bold;

      display: flex  !important;
      justify-content: center !important;
      margin: 5px;
      border-radius: 8px;

      transition: 0.5s all;
      border: 0;
      border-radius: 2px;

      &:hover {
        color: yellow !important;
      background: #333  !important;

      box-shadow: 0px 5px 10px rgba(255,255,100,0.3);
      }
    }

    button.redButton{
      background: rgb(200,0,0) !important;

      &:hover {
        background:  rgb(150,0,0)  !important;
      }
    }

    .closeButton{
      padding: 10px;
      border: 0;
      opacity: 0.8;
      background: #555;
      color: #fff;
      transition: 0.5s all;

      margin: 5px;
      &:hover{
        opacity: 1;
      }
    }


    a {
      text-decoration: none !important;
    }

    .separator {
    width: 100%;

    height: 2px;
    background: yellow;
    margin: 10px 0;
  }


  .covidDiv{
    background: url('/assets/evento/covid.jpg') no-repeat center;
    background-size: cover;
    padding: 20px;
    display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

    >div {
      max-width: 600px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 200px;
      >h2 {
        margin-bottom: 20px;
      }
     > h2, >p {
        color: #fff;

      }

      >p{
        text-align: justify;
      }
    }
  }

  .defaultMarked{
    padding: 15px;

  
   position: relative;
    color: ${defaultTheme.defaultBackground} !important;
    text-transform: uppercase;
    min-height: 8px;
    font-size: 1.7em !important;
 
    @media (max-width: 750px) {
      font-size: 1.7em !important;
  }
 >div {
   width: 0px;
   height: 8px;
   border-radius: 8px;

   position: absolute;
top: 80%;
   left: 0px;
   background: #fff  !important;
   z-index: -1;
   animation: ${move} 3s none ; 
   animation-fill-mode: forwards;
 }


  }

  .defaultTitle{
    display: flex;
    border-radius: 10px;
    background: rgb(0, 102, 178);
    transition: 0.5s all;
    padding: 40px 20px;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    margin-bottom: 30px;
    transition: 0.4s all;
    background: ${defaultTheme.defaultBackground}  !important;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);


  }

.blurAnimation {
  animation :${blurEnter} 3s;
  animation-fill-mode: forwards;
animation-delay: 4s;
opacity: 0;
}


.whatsappButton{
  position: absolute;
  left: 80%;
  bottom: 0px;
  transform: translatex(-50%);
  cursor: pointer;

  >button{
    background: rgb(0,150,50);
    color: #fff;
    font-size: 18px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fff;
    transition: 0.4s all;
    border-radius: 50%;

    &:hover{
      border: 2px solid yellow;
    }
  }
}



.table {
border-collapse: collapse;

thead, tbody{
  >tr {
   
    >td, >th{
  padding: 10px;
   border: 1px solid #fff;
}
  }
}
}

.pulsing {
  animation: ${pulsing} 1s infinite reverse;
  display: flex;


}

input, select{
  font-family: Montserrat, sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;





/*Change text in autofill textbox*/
&:-webkit-autofill,
&:-webkit-autofill:hover,
&:-webkit-autofill:focus,
&:-webkit-autofill:active {
    -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
    -webkit-transition-delay: 9999s;
}
}

`;
